// eslint-disable-next-line import/prefer-default-export
export const MAX_SIZE_FILE_UPLOAD = 5242880;
export const LIST_STATUS_SUPPORT = [
  {
    id: 1, name: 'Mới', color: '#03A9F4',
  },
  {

    id: 2, name: 'Đang xử lý', color: '#FF6D00',
  },
  {

    id: 3, name: 'Chờ duyệt', color: '#FFC400',
  },
  {

    id: 4, name: 'Tạm dừng', color: '#A0A0A0',
  },
  {
    id: 5, name: 'Hoàn thành', color: '#5AC725',
  },
  {
    id: 6, name: 'Hủy', color: '#FF3D00',
  },
];
export const PRIORITY_SUPPORT = [
  {
    value: 1, name: 'Thấp', color: '#FFE500',
  },
  {
    value: 2, name: 'Trung bình', color: '#47A6F9',
  },
  {
    value: 3, name: 'Cao', color: '#E83232',
  },
];
